// import {
//   NavigateFunction,
//   useNavigate,
//   Params,
//   useParams,
// } from "react-router-dom";

// type TParamsProps = {
//   params: Readonly<Params<string>>;
//   navigation: NavigateFunction;
// };

// export default function withParams<T extends TParamsProps>(
//   WrappedComponent: React.ComponentType<T>
// ): React.ComponentType<Omit<T, keyof TParamsProps>> {
//   return (props: Omit<T, keyof TParamsProps>) => (
//     <WrappedComponent
//       {...props}
//       params={useParams<string>()}
//       navigation={useNavigate()}
//     />
//   );
// }
import { useLocation, useNavigate, useParams } from "react-router-dom";

export default function withRouterDom(WrappedComponent: any): any {
  return (props: any) => (
    <WrappedComponent
      {...props}
      params={useParams()}
      navigation={useNavigate()}
      location={useLocation()}
    />
  );
}
